export const PublishAudit = {
  title: "Recommended Audits",
  message: "New audit has been published",
  linkurl: "/audits-opening-list",

  notificationtype: "Global",
};
export const PublishJob = {
  title: "Recommended Jobs",
  message: "New job has been published.",
  linkurl: "/jobs-opening-list",

  notificationtype: "Global",
};

export const StatusAuditNotification = (status, title) => {
  let notificationType = "Audit";
  let notificationMessage;

  switch (status) {
    case "Approved":
      notificationMessage = `Your request has been approved`;
      break;
    case "Inprogress" || "InProgress":
      notificationMessage = `Your request has been in progress`;
      break;
    case "Rejected":
      notificationMessage = `Your request has been rejected`;
      break;
    case "Review":
      notificationMessage = `Your request has been reviewed`;
      break;
    case "Reviewed":
      notificationMessage = `Your request has been reviewed`;
      break;
    case "Pending":
      notificationMessage = `Your request has been pending`;
      break;
    default:
      notificationMessage = "";
  }

  return {
    title: title === "Audit" ? "Audit Status" : "Job Status",
    message: notificationMessage,
    linkurl: "",
    notificationtype: notificationType,
  };
};
